import { Injectable } from '@angular/core';

import { HttpService } from '../http/http.service';
import { environment } from '../../../environments/environment';

@Injectable()
export class DeliAreaService {
  private apiUrl = '/deliareas';

  constructor(private http: HttpService) { }

  get(ownerId: number, query?: any): Promise<any> {
    const url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiUrl}`;
    return this.http.get(url, query);
  }

  post(
    ownerId: number,
    deliareaCd: string,
    deliareaTx: string,
    updprogramCd: string
  ): Promise<any> {
    const url = `${environment.baseUrl}/owners/${ownerId + this.apiUrl}`;
    const jsonInput = {
      deliareaCd: deliareaCd,
      deliareaTx: deliareaTx,
      updprogramCd: updprogramCd
    };

    return this.http.post(url, jsonInput);
  }

  put(
    ownerId: number,
    deliareaId: number,
    deliareaCd: string,
    deliareaTx: string,
    updprogramCd: string
  ): Promise<any> {
    const url = `${environment.baseUrl}/owners/${ownerId + this.apiUrl}/${deliareaId}`;
    const jsonInput = {
      deliareaCd: deliareaCd,
      deliareaTx: deliareaTx,
      updprogramCd: updprogramCd
    };

    return this.http.put(url, jsonInput);
  }

  delete(
    ownerId: number,
    deliareaId: number
  ): Promise<any> {
    const url = `${environment.baseUrl}/owners/${ownerId + this.apiUrl}/${deliareaId}`;
    return this.http.delete(url);
  }
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/service/deli-area/deli-area.service.ts